module.exports = __webpack_public_path__ + "assets/img/ptcl-group.png?01c260351dd5cd01e7b259802b40e5df";